<template>
  <BaseModal
    hookSufix="AiCtaModal"
    :title="$i18next.t('message.ai.ctaModal.title')"
    :subtitle="$i18next.t('message.ai.ctaModal.subtitle')"
    :onCloseHook="onClose"
  >
    <template #content>
      <div class="mx-auto container__ia-features">
        <v-row>
          <v-col>
            <v-card flat class="d-flex justify-start align-center">
              <img src="@/assets/pandaChip.svg" width="41px" />
              <div>
                <v-card-title>
                  <span
                    class="text-body-2 font-weight-medium"
                    :class="{
                      'neutral--text': !$vuetify.theme.dark,
                    }"
                  >
                    {{ $i18next.t('message.ai.ctaModal.briefing.title') }}
                  </span>
                </v-card-title>
                <v-card-subtitle>
                  <span
                    class="text-body-2 font-weight-regular"
                    :class="{
                      'neutral--text': !$vuetify.theme.dark,
                    }"
                  >
                    {{ $i18next.t('message.ai.ctaModal.briefing.sub') }}
                  </span>
                </v-card-subtitle>
              </div>
            </v-card>
          </v-col>
          <v-col>
            <v-card outlined class="v-card__custom-border">
              <v-card-title class="pb-0">
                <simple-svg
                  :src="require('@/assets/dubbing.svg')"
                  fill-class-name="fill-color"
                  fill="var(--v-brand-lighten1)"
                  width="24px"
                />
                <span
                  class="text-body-1 font-weight-medium ml-1"
                  :class="{
                    'neutral--text text--lighten-1 ': !$vuetify.theme.dark,
                  }"
                >
                  {{ $i18next.t('message.ai.ctaModal.dubbings.title') }}
                </span>
              </v-card-title>
              <v-card-subtitle class="mt-2">
                <span
                  class="text-body-2 font-weight-regular"
                  :class="{
                    'neutral--text': !$vuetify.theme.dark,
                  }"
                >
                  {{ $i18next.t('message.ai.ctaModal.dubbings.sub') }}
                </span>
              </v-card-subtitle>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-card outlined class="v-card__custom-border">
              <v-card-title class="pb-0">
                <simple-svg
                  :src="require('@/assets/cc_tooltip.svg')"
                  fill-class-name="fill-color"
                  fill="var(--v-brand-lighten1)"
                  width="29px"
                />
                <span
                  class="text-body-1 font-weight-medium ml-1"
                  :class="{
                    'neutral--text text--lighten-1 ': !$vuetify.theme.dark,
                  }"
                >
                  {{ $i18next.t('message.ai.ctaModal.subtitles.title') }}
                </span>
              </v-card-title>
              <v-card-subtitle class="mt-2">
                <span
                  class="text-body-2 font-weight-regular"
                  :class="{
                    'neutral--text': !$vuetify.theme.dark,
                  }"
                >
                  {{ $i18next.t('message.ai.ctaModal.subtitles.sub') }}
                </span>
              </v-card-subtitle>
            </v-card>
          </v-col>
          <v-col>
            <v-card outlined class="v-card__custom-border">
              <v-card-title class="pb-0">
                <simple-svg
                  :src="require('@/assets/ebook.svg')"
                  fill-class-name="fill-color"
                  fill="var(--v-brand-lighten1)"
                  width="24px"
                  height="24px"
                />
                <span
                  class="text-body-1 font-weight-medium ml-1"
                  :class="{
                    'neutral--text text--lighten-1 ': !$vuetify.theme.dark,
                  }"
                >
                  {{ $i18next.t('message.ai.ctaModal.ebook.title') }}
                </span>
              </v-card-title>
              <v-card-subtitle class="mt-2">
                <span
                  class="text-body-2 font-weight-regular"
                  :class="{
                    'neutral--text': !$vuetify.theme.dark,
                  }"
                >
                  {{ $i18next.t('message.ai.ctaModal.ebook.sub') }}
                </span>
              </v-card-subtitle>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-card outlined class="v-card__custom-border">
              <v-card-title class="pb-0">
                <simple-svg
                  :src="require('@/assets/mindMap.svg')"
                  fill-class-name="fill-color"
                  fill="var(--v-brand-lighten1)"
                  width="24px"
                  height="24px"
                />
                <span
                  class="text-body-1 font-weight-medium ml-1"
                  :class="{
                    'neutral--text text--lighten-1 ': !$vuetify.theme.dark,
                  }"
                >
                  {{ $i18next.t('message.ai.ctaModal.mindmap.title') }}
                </span>
              </v-card-title>
              <v-card-subtitle class="mt-2">
                <span
                  class="text-body-2 font-weight-regular"
                  :class="{
                    'neutral--text': !$vuetify.theme.dark,
                  }"
                >
                  {{ $i18next.t('message.ai.ctaModal.mindmap.sub') }}
                </span>
              </v-card-subtitle>
            </v-card>
          </v-col>
          <v-col>
            <v-card outlined class="v-card__custom-border">
              <v-card-title class="pb-0">
                <v-icon size="24px" color="var(--v-brand-lighten1)"
                  >mdi-help-box-multiple</v-icon
                >
                <span
                  class="text-body-1 font-weight-medium ml-1"
                  :class="{
                    'neutral--text text--lighten-1 ': !$vuetify.theme.dark,
                  }"
                >
                  {{ $i18next.t('message.ai.ctaModal.quiz.title') }}
                </span>
              </v-card-title>
              <v-card-subtitle class="mt-2">
                <span
                  class="text-body-2 font-weight-regular"
                  :class="{
                    'neutral--text': !$vuetify.theme.dark,
                  }"
                >
                  {{ $i18next.t('message.ai.ctaModal.quiz.sub') }}
                </span>
              </v-card-subtitle>
            </v-card>
          </v-col>
        </v-row>
      </div>
      <div class="d-flex justify-center pb-9">
        <BaseBtn class="mt-11" @click="$root.$emit('closeAiCtaModal')">
          {{ $i18next.t('message.ai.ctaModal.actionBtn') }}</BaseBtn
        >
      </div>
    </template>
  </BaseModal>
</template>

<script>
import Storage from '@/utils/Storage.js'
import BaseModal from './BaseModal.vue'
import BaseBtn from './BaseBtn.vue'

export default {
  name: 'AiCtaModal',
  components: { BaseModal, BaseBtn },
  methods: {
    onClose() {
      this.$root.$emit('AiCtaModalHasClosed')
      Storage.setItem('hasSeenAiCtaModal', true)
    },
  },
}
</script>

<style lang="scss">
.v-card__custom-border {
  border: thin solid var(--v-neutral-lighten3) !important;
}

.container__ia-features {
  margin-top: 57px;
  max-width: 100%;
  width: 610px;

  .row .col {
    padding: 4px !important;
  }
}
</style>
